var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15C5 14.0795 6.11929 13.3333 7.5 13.3333C8.88071 13.3333 10 14.0795 10 15M15 11.6667H11.6667M15 9.16667H12.5M9.16667 9.16667C9.16667 10.0871 8.42047 10.8333 7.5 10.8333C6.57953 10.8333 5.83333 10.0871 5.83333 9.16667C5.83333 8.24619 6.57953 7.5 7.5 7.5C8.42047 7.5 9.16667 8.24619 9.16667 9.16667ZM3.33333 5H16.6667C17.1269 5 17.5 5.3731 17.5 5.83333V14.1667C17.5 14.6269 17.1269 15 16.6667 15H3.33333C2.8731 15 2.5 14.6269 2.5 14.1667V5.83333C2.5 5.3731 2.8731 5 3.33333 5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIdCard);
export default __webpack_public_path__ + "static/media/UserIdCard.ec9354ec.svg";
export { ForwardRef as ReactComponent };